import { useState, useCallback } from "react";
import MainLayout from "src/layouts/MainLayout";
import EmployeeTable from "src/components/EmployeeTable";
import { Button } from "@porchpass/ui";
import { useDealerUserInfo } from "src/context/DealerUserInfoContext";

const AddEmployeeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    className="shrink-0"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_449_1095)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6875 10.3125C14.1 10.3125 14.4375 10.65 14.4375 11.0625V12.9375H16.3125C16.725 12.9375 17.0625 13.275 17.0625 13.6875C17.0625 14.1 16.725 14.4375 16.3125 14.4375H14.4375V16.3125C14.4375 16.725 14.1 17.0625 13.6875 17.0625C13.275 17.0625 12.9375 16.725 12.9375 16.3125V14.4375H11.0625C10.65 14.4375 10.3125 14.1 10.3125 13.6875C10.3125 13.275 10.65 12.9375 11.0625 12.9375H12.9375V11.0625C12.9375 10.65 13.275 10.3125 13.6875 10.3125Z"
        fill="white"
      />
      <path
        opacity="0.4"
        d="M10.8458 11.8275L9.56329 11.4375V9.98254C10.8983 8.94004 11.8133 7.68753 11.8133 5.00253C11.8133 3.26253 11.4983 1.6875 9.59329 1.6875C9.59329 1.6875 8.9258 0.9375 7.3058 0.9375C5.0258 0.9375 3.56329 2.31003 3.56329 5.00253C3.56329 7.69503 4.47829 8.94004 5.81329 9.98254V11.4375L3.02329 12.2775C1.98079 12.5925 1.2083 13.4325 0.953295 14.445C0.848295 14.85 1.20079 15.1875 1.61329 15.1875H9.9308C9.4733 14.8425 9.1808 14.3025 9.1808 13.6875C9.1808 12.7275 9.90829 11.9325 10.8383 11.8275H10.8458Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_449_1095">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default () => {
  const { dealerUserInfo } = useDealerUserInfo();
  const canManageEmployees =
    dealerUserInfo.is_admin || dealerUserInfo.role === "GENERAL_MANAGER";
  const [totalEmployeeCount, setTotalEmployeeCount] = useState<
    number | undefined
  >(undefined);
  const [createHandler, setCreateHandler] = useState<(() => void) | null>(null);

  const handleRegisterCreateHandler = useCallback((handler: () => void) => {
    setCreateHandler(() => handler);
  }, []);

  return (
    <MainLayout
      page="employees"
      totalCount={totalEmployeeCount}
      headerAction={
        canManageEmployees &&
        createHandler && (
          <Button variant="primary" size="s" onClick={createHandler}>
            <AddEmployeeIcon />
            Add employee
          </Button>
        )
      }
    >
      <EmployeeTable
        updateTotalEmployeeCount={setTotalEmployeeCount}
        onRegisterCreateHandler={handleRegisterCreateHandler}
        canManageEmployees={canManageEmployees}
      />
    </MainLayout>
  );
};
